import React from 'react';
import { useState } from 'react';
import './OurTeam.css';
import logoOfOurProject1 from '../Images/logoOfOurProject1.jpg';
import TeamsMember4 from '../Images/Teams-member4.jpg';
import TeamsMember2 from '../Images/Teams-member2.jpg';
import projectLeader from '../Images/Tushar.jpg'
import coFounder1 from '../Images/nikhil.jpg';
import coFounder2 from '../Images/Alok.jpg';
import useScrollAnimation from './scroll';
import { Link } from 'react-router-dom';

const OurTeam = () => {

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [courses, setCourses] = useState([
        { id: 1, title: 'MLOps Pro Specialization', path: '/mlops' },
        { id: 2, title: 'Mastering Data Analysis with Python', path: '/DataAnalysisWithPython' },
        { id: 3, title: 'Mastering GenAI Specialisation', path: '/masteringGenAI' },
        { id: 4, title: 'Data Science Masterclass', path: '/datasciencemasterclass' },
        { id: 5, title: 'Advanced LLM Ops Specialization', path: '/advancedllm' }

        // Add more courses here or fetch from an API
    ]);

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        // Filter the courses based on the search query
        if (query) {
            const filtered = courses.filter((course) =>
                course.title.toLowerCase().includes(query)
            );
            setFilteredCourses(filtered);
        } else {
            setFilteredCourses([]);
        }
    };

    useScrollAnimation(); // Activate scroll animations

    return (
        <div className="container">
            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid">
                    <a href='/'><img src={logoOfOurProject1} alt='logo' /></a>
                    {/* <a className="navbar-brand fw-bold" href="/">KOTI AI</a> */}
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-5">
                            <li className="nav-item me-3">
                                <a className="nav-link active fw-medium" aria-current="page" href="/">Home</a>
                            </li>
                            <li className="nav-item me-3">
                                <a className="nav-link fw-medium" href="#">Courses</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="datasciencemasterclass">Data Science</a></li>
                                    <li><a className="dropdown-item" href="/dataAnalysisWithPython">Data Analysis</a></li>
                                    <li><a className="dropdown-item" href="/masteringandbuildingproduct">Mastering AI Product- Langchain & LangGraph</a></li>
                                    <li><a className="dropdown-item" href="/productmanagementinai">Product Management In AI</a></li>
                                    <li><a className="dropdown-item" href="/masteringGenAI">Mastering GenAI</a></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><a className="dropdown-item" href="/allcourses">More Courses</a></li>
                                </ul>
                            </li>
                            <li className="nav-item me-3">
                                <a className="nav-link fw-medium" href="#">Service</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="#">Product Development</a></li>
                                    <li><a className="dropdown-item" href="/trainingandworkshop">Training & Workshops</a></li>
                                    <li><a className="dropdown-item" href="#">Customer Success</a></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link fw-medium" href="#">About</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="ourteam">Our Team</a></li>
                                    {/* <li><a className="dropdown-item" href="#">Mission & Vision</a></li> */}
                                    <li><a className="dropdown-item" href="#">Reviews</a></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><a className="dropdown-item" href="#contact-section">Contact Us</a></li>
                                </ul>
                            </li>
                        </ul>
                        {/* <form className="d-flex" role="search">
                            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                            <button className="btn btn-outline-success" type="submit">Search</button>
                        </form> */}

                        <div className="search-bar-container" style={{ position: 'relative', width: '50%' }}>
                            <form className="d-flex" role="search" onSubmit={(e) => e.preventDefault()}>
                                <input
                                    className="form-control me-2"
                                    type="search"
                                    value={searchQuery}
                                    onChange={handleSearch}
                                    placeholder="Search for courses..."
                                    aria-label="Search"
                                    autoComplete="on"
                                />
                                <button className="btn btn-outline-success" type="submit">Search</button>

                                {/* Dropdown search results */}
                                {searchQuery && filteredCourses.length > 0 && (
                                    <div className="dropdown-search-results">
                                        <ul>
                                            {filteredCourses.map((course) => (
                                                <li key={course.id}>
                                                    <Link to={course.path} onClick={() => setSearchQuery('')}>
                                                        {course.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </form>


                        </div>

                    </div>
                </div>
            </nav>

            {/* Intro Section with Immediate Animation */}
            <div className='container flex-wrap w-100 intro-section fade-in-immediate'>
                <div className='container justify-content-center p-5 ourteam-left'>
                    <h2 className='font-size-1'>
                        Learn From the Best in Technology
                    </h2>
                    <p>
                        Our courses are led by seasoned professionals with decades of experience at renowned organizations and prestigious Tier 1 institutions. With us, you’ll master <span className="highlight-gradient_2">Artificial Intelligence</span> tools and applications directly from the experts shaping the field.
                    </p>
                    <h2 className='font-size-1'>
                        Why Choose Our Certification Programs?
                    </h2>
                    <p>
                        Our programs are recognized as the gold standard in upskilling. We offer exclusive hands-on, live online sessions led by product leaders from top tech companies such as Google, Meta, Amazon, Netflix, and Airbnb. Get real-world insights and practical skills from those who know the industry inside out.
                    </p>
                </div>

                {/* Co-founders Section with Scroll Animation */}
                <div className='container d-flex flex-wrap justify-content-center cofounder-section fade-in'>
                    <div className='card cofounder-card'>
                        <img src={coFounder1} alt='Nikhil' className='rounded-circle cofounder-img' />
                        <div className="card-body text-center">
                            <h4>Nikhil</h4>
                            <p className='cofounder-title'>Co-founder</p>
                        </div>
                    </div>
                    <div className='card cofounder-card'>
                        <img src={coFounder2} alt='Alok' className='rounded-circle cofounder-img' />
                        <div className="card-body text-center">
                            <h4>Alok</h4>
                            <p className='cofounder-title'>Co-founder</p>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <hr />
            <br />

            {/* Team Members Section with Scroll Animation */}
            <h2 className='container fw-bold p-4 text-center fade-in'>Meet Our Team Members</h2>
            <div className='container d-flex flex-wrap team-section fade-in'>
                <div className="card team-card">
                    <img src={projectLeader} className="card-img-top team-img" alt="Tushar Chaudhary" />
                    <div className="card-body text-center">
                        <h4>Tushar Chaudhary</h4>
                        <p className="card-text">Project Leader</p>
                    </div>
                </div>
                <div className="card me-1 team-card">
                    <img src={TeamsMember2} className="card-img-top team-img" alt="Rohit Deshwal" />
                    <div className="card-body text-center">
                        <h4>Rohit Deshwal</h4>
                        <p className="card-text">Junior Lead</p>
                    </div>
                </div>
                <div className="card me-1 team-card">
                    <img src={TeamsMember4} className="card-img-top team-img" alt="Akshay Goel" />
                    <div className="card-body text-center">
                        <h4>Akshay Goel</h4>
                        <p className="card-text">Employee</p>
                    </div>
                </div>
            </div>

            <footer className='footer p-4 bg-dark' id='contact-section'>
                <div className='d-flex justify-content-between' id='contact-section'>
                    <div className='footer-social text-white'>
                        <h4>Follow us!</h4>
                        <div className='footer-social-links-1'>
                            <a href="https://www.facebook.com/imtusharchaudhary" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Facebook-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                            <a href="https://www.Twitter.com/Tusharcofficial" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Twitter-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                            <a href="https://www.instagram.com/iamtusharchaudhry" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Instagram-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                        </div>
                    </div>
                    <div className='AboutCompany text-white'>
                        <h4>Company</h4>
                        <p>Careers</p>
                        <p>Newsroom</p>
                        <p>Alumni Speak</p>
                        <p>Grievance redreesal</p>
                    </div>
                    <div className='WorkWithUs text-white'>
                        <h4>Work With Us</h4>
                        <p className='text-white-50'>Become an instructor</p>
                        <p className='text-white-50'>Blog as guest</p>
                    </div>
                    <div className='ForBusinesses text-white'>
                        <h4>Contact Us</h4>
                        <p className='text-white-50'><i class="bi bi-phone"></i>&nbsp; Request a callback</p>
                        <p className='text-white-50'><i class="bi bi-telephone-plus-fill"></i>&nbsp; +91 8448-313599</p>
                        <p className='text-white-50'><i class="bi bi-envelope-fill"></i>&nbsp; info@kotiai.com</p>
                    </div>
                </div>
                <div className='footer-bottom'>
                    <p>© 2024 kotiai.com | Terms of Service | Privacy Policy</p>
                </div>
            </footer>
        </div>
    );
};

export default OurTeam;
